export const modal = {
  namespaced: true,
  state: {
    showModal: false,
    mode: 'logged-out',
    step: null,
    callback: null,
    content: {
      title: '',
      subtitle: '',
      html: '',
      confirm: '',
      cancel: '',
      additional: {},
    },
  },
  getters: {
    getContent(state) {
      return state.content;
    },
    showModal(state) {
      return state.showModal;
    },
    getCallback(state) {
      return state.callback;
    },
    getModalMode(state) {
      return state.mode;
    },
    getModalStep(state) {
      return state.step;
    },
  },
  actions: {
    setContent({ commit }, content) {
      commit('setContent', content);
    },
    openModal({ commit }) {
      commit('setModalVisibility', true);
    },
    closeModal({ commit }) {
      commit('setModalVisibility', false);
      setTimeout(() => commit('setModalStep', null), 250);
    },
    setCallback({ commit }, callback) {
      commit('setCallback', callback);
    },
    setModalMode({ commit }, mode) {
      commit('setModalMode', mode);
    },
    setModalStep({ commit }, step) {
      commit('setModalStep', step);
    },
  },
  mutations: {
    setContent(state, content) {
      state.content = content;
    },
    setModalVisibility(state, value) {
      state.showModal = value;
    },
    setCallback(state, callback) {
      state.callback = callback;
    },
    setModalMode(state, mode) {
      state.mode = mode;
    },
    setModalStep(state, step) {
      state.step = step;
    },
  },
};
